// Layout Components
import AppBar from './AppBar';
import Drawer from './Drawer';

// Form Components
import Autocomplete from './Autocomplete';
import Button from './Button';
import Checkbox from './Checkbox';
import DatePicker from './DatePicker';
import Radio from './Radio';
import Select from './Select';
import Switch from './Switch';
import TextField from './TextField';

// Feedback Components
import Alert from './Alert';
import Dialog from './Dialog';
import Progress from './Progress';
import Snackbar from './Snackbar';
import Tooltip from './Tooltip';

// Data Display Components
import Avatar from './Avatar';
import Badge from './Badge';
import Card from './Card';
import Chip from './Chip';
import Rating from './Rating';
import Table from './Table';
import Tabs from './Tabs';

// Navigation Components
import Breadcrumbs from './Breadcrumbs';
import Menu from './Menu';
import Navigation from './Navigation';
import Pagination from './Pagination';
import Stepper from './Stepper';

// Layout & Container Components
import Accordion from './Accordion';
import Container from './Container';
import Divider from './Divider';
import Grid from './Grid';
import List from './List';
import Paper from './Paper';
import Slider from './Slider';

export default function componentsOverride(theme) {
  const components = {};
  
  Object.assign(
    components,
    // Layout Components
    AppBar(theme),
    Drawer(theme),
    // Form Components
    Autocomplete(theme),
    Button(theme),
    Checkbox(theme),
    DatePicker(theme),
    Radio(theme),
    Select(theme),
    Switch(theme),
    TextField(theme),
    // Feedback Components
    Alert(theme),
    Dialog(theme),
    Progress(theme),
    Snackbar(theme),
    Tooltip(theme),
    // Data Display Components
    Avatar(theme),
    Badge(theme),
    Card(theme),
    Chip(theme),
    Rating(theme),
    Table(theme),
    Tabs(theme),
    // Navigation Components
    Breadcrumbs(theme),
    Menu(theme),
    Navigation(theme),
    Pagination(theme),
    Stepper(theme),
    // Layout & Container Components
    Accordion(theme),
    Container(theme),
    Divider(theme),
    Grid(theme),
    List(theme),
    Paper(theme),
    Slider(theme)
  );

  return components;
} 